import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-update-not-display-in-dropdowns-modal',
  templateUrl: './update-not-display-in-dropdowns-modal.component.html',
  styleUrls: ['./update-not-display-in-dropdowns-modal.component.scss']
})
export class UpdateNotDisplayInDropdownsModalComponent implements OnInit {
  @Input() length: any;
  @Input() parametres: any;
  result = true;
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  close() {
    this.activeModal.dismiss('dismiss');
  }

  valid() {
    this.activeModal.close(this.result);
  }

}
